module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newBoat"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Añadir equipaje\r\n              ")])], 1)]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "form-order"
  }, [_c('div', {
    staticClass: "form_container form-flex"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-test text-title formResume"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_vm._m(9), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn-primary"
  }, [_vm._v("Guardar")])], 1)]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "purchaseOrders"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(16), _vm._v(" "), (_vm.$store.state.user.attributes.permissions_keys.includes(8)) ? _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalNewUser"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.formmodal",
      modifiers: {
        "formmodal": true
      }
    }],
    staticClass: "btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("Crear nuevo usuario\r\n            ")])], 1) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-content"
  }, [_c('span', {
    staticClass: "statusInit"
  }, [_vm._v("Inicializando")]), _vm._v(" "), _c('span', {
    staticClass: "statusProgress"
  }, [_vm._v("En proceso")]), _vm._v(" "), _c('span', {
    staticClass: "statusCancel"
  }, [_vm._v("Cancelado")]), _vm._v(" "), _c('p', [_vm._v("En re-evaluación inicial")]), _vm._v(" "), _c('p', [_vm._v("Re-evaluado esperando confirmación")]), _vm._v(" "), _c('p', [_vm._v("Re-evaluado esperando confirmación")]), _vm._v(" "), _c('p', [_vm._v("Completando información de compra")]), _vm._v(" "), _c('p', [_vm._v("Comprado y en camino a dirección de origen")]), _vm._v(" "), _c('p', [_vm._v("Recibido en dirección de origen y en evaluación")]), _vm._v(" "), _c('p', [_vm._v("Listo para embarque")]), _vm._v(" "), _c('p', [_vm._v("En proceso de embarque")]), _vm._v(" "), _c('p', [_vm._v("Entregado correctamente")]), _vm._v(" "), _c('p', [_vm._v("Cancelado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-titulo text-title"
  }, [_c('h1', [_vm._v("Orden de compra #B56764-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step_container"
  }, [_c('ul', {
    staticClass: "progressbar"
  }, [_c('li', {
    staticClass: "inprocess",
    attrs: {
      "id": "li1",
      "href": "#"
    }
  }, [_c('p', [_vm._v("Datos del embarque")])]), _vm._v(" "), _c('li', {
    staticClass: "disabled",
    attrs: {
      "id": "li2"
    }
  }, [_c('p', [_vm._v("Agregar equipaje")])]), _vm._v(" "), _c('li', {
    staticClass: "disabled",
    attrs: {
      "id": "li3"
    }
  }, [_c('p', [_vm._v("Agregar órdenes")])]), _vm._v(" "), _c('li', {
    staticClass: "disabled",
    attrs: {
      "id": "li4"
    }
  }, [_c('p', [_vm._v("Embarcar")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', [_c('h1', [_vm._v("Datos del embarque")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Destino")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Miami")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control null",
    attrs: {
      "rows": "3",
      "cols": "70"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de salida"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "max": "2100-12-31"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "max": "2100-12-31"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', [_c('h1', [_vm._v("Datos del equipaje")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de equipaje")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Maleta")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control null",
    attrs: {
      "rows": "3",
      "cols": "70"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Equipaje")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-login text-title formResume"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina vitrinaSuitcase"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productSuitcase"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "emptyVitrina"
  }, [_c('p', [_vm._v("No has añadido equipaje")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v("10 kg")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-test text-title formResume"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tus órdenes")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-order"
  }, [_c('div', {
    staticClass: "chooseOrder"
  }, [_c('div', {
    staticClass: "filter-search",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "text",
      "placeholder": "Buscar..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "product productOrder"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag tag-alta"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")]), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("Medio")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Quitar")])])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tu embarque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v("10 kg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-order"
  }, [_c('div', {
    staticClass: "resumeOrder"
  }, [_c('div', {
    staticClass: "filter-search",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "text",
      "placeholder": "Buscar..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "imageContent"
  }, [_c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "suitCase-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Resumen del embarque")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-login text-title formResume"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina vitrinaSuitcase"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('h3', {
    staticClass: "productName"
  }, [_vm._v("Laptop 15.6\" 320-15 AMD A12 16GB 2TB Azul")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("#B56764-1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('div', {
    staticClass: "cantidad"
  }, [_c('input', {
    staticClass: "num ctrl-num",
    attrs: {
      "type": "tel",
      "value": "1",
      "data-max": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "up ctrl-max disabled"
  }), _vm._v(" "), _c('div', {
    staticClass: "down ctrl-min"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger proAdd",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v("10 kg")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newTracking"
    }
  }, [_c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Comprado y en camino a dirección de origen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Evaluar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Recibido y completando datos de recpeción")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Listo para embarcar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newTracking-SameStore"
    }
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta de compra demorada")]), _vm._v(" "), _c('h2', [_vm._v("Oferta de compra demorada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTypeReplacement"
    }
  }, [_vm._v("Generar incidencia")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidencia")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalReplacement"
    }
  }, [_vm._v("Generar reemplazo")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Orden cancelada por reemplazo, ver "), _c('span', [_vm._v("nueva orden aqui")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "newTracking-OtherStore"
    }
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta de compra demorada")]), _vm._v(" "), _c('h2', [_vm._v("Oferta de compra demorada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalNewTracking"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTypeReplacement"
    }
  }, [_vm._v("Generar incidencia")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidencia")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalRefund"
    }
  }, [_vm._v("Informacion de reembolso")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "/tasks"
    }
  }, [_vm._v("Generar reemplazo")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Orden cancelada por reemplazo, ver "), _c('span', [_vm._v("nueva orden aqui")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "testOrder"
    }
  }, [_c('div', {
    staticClass: "card card-standby"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta por evaluar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Evaluar")])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta no aprobada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalExtraInfo"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinThree",
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Oferta aprobada")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalExtraInfo"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-standby card-wait"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinFive",
      "data-toggle": "collapse",
      "data-target": "#collapsenFive",
      "aria-expanded": "true",
      "aria-controls": "collapseFive"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Esperando revision del administrador")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalTest"
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#modalExtraInfo"
    }
  }, [_vm._v("Procesar")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenFive",
      "aria-labelledby": "headingnFive",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "container-type"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen-top"
  }, [_c('h1', [_vm._v("Listo para embarque")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Lista de usuarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "filter-search"
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-status"
  }, [_c('select', {
    staticClass: "form-control form-filter"
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Operador de envío")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Operador de recepcion")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-edit is-bordered data-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nombre del usuario")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Fecha de creacion")]), _vm._v(" "), _c('th', [_vm._v("Ultima actualizacion")]), _vm._v(" "), _c('th', [_vm._v("Accion")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Jose Catillo")]), _vm._v(" "), _c('td', [_vm._v("Administrador")]), _vm._v(" "), _c('td', [_vm._v("22/34/2019")]), _vm._v(" "), _c('td', [_vm._v("22/34/2019")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "dropdown show"
  }, [_c('button', {
    staticClass: "btn-icon btn-icon-only btn btn-danger btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fas fa-trash-alt"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-icon btn-icon-only btn btn-warning btn-sm",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalEditUser"
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_container"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "userContent"
  }, [_c('div', {
    staticClass: "userCard"
  }, [_c('div', {
    staticClass: "author"
  }, [_c('img', {
    staticClass: "avatar border-gray",
    attrs: {
      "src": "https://demos.creative-tim.com/now-ui-dashboard/assets/img/mike.jpg",
      "alt": "..."
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "title"
  }, [_vm._v("Jose Castillo")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\r\n                      Administrador\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "user-details"
  }, [_c('div', {
    staticClass: "row-details"
  }, [_c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("ID o DNI")]), _vm._v(" "), _c('span', [_vm._v("98768954")])]), _vm._v(" "), _c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("Telefono")]), _vm._v(" "), _c('span', [_vm._v("+51 921 276 643")])])]), _vm._v(" "), _c('div', {
    staticClass: "row-details"
  }, [_c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("Correo")]), _vm._v(" "), _c('span', [_vm._v("erick.22@gmail.com")])]), _vm._v(" "), _c('div', {
    staticClass: "blockDetails"
  }, [_c('span', [_vm._v("Tipo")]), _vm._v(" "), _c('span', [_vm._v("Administrador")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form_container userForm"
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Datos de usuario")])])]), _vm._v(" "), _c('div', {
    staticClass: "formItem"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "Jose Castillo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Correo electronico"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "josecastillo@gmail.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ID o DNI"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "45678908"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pais"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "Peru"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Zip code"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "placeholder": "5566"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Guardar")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-image"
  }, [_c('div', {
    staticClass: "image-order"
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-title text-title"
  }, [_c('h1', [_vm._v("Apple iPhone 7 Plus Factory desbloqueado CDMA/GSM teléfono inteligente")]), _vm._v(" "), _c('p', [_vm._v("Oferta genera de"), _c('span', {
    staticClass: "order-type"
  }, [_vm._v("Grabr")])]), _vm._v(" "), _c('p', [_vm._v("Cantidad"), _c('span', {
    staticClass: "order-cant"
  }, [_vm._v("1")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Detalles de la orden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingSeven",
      "data-toggle": "collapse",
      "data-target": "#collapseseven",
      "aria-expanded": "false",
      "aria-controls": "collapseSeven"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos de reembolso")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSeven",
      "aria-labelledby": "headingSeven",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingFour",
      "data-toggle": "collapse",
      "data-target": "#collapseFour",
      "aria-expanded": "false",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos del cliente")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseFour",
      "aria-labelledby": "headingFour",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingFive",
      "data-toggle": "collapse",
      "data-target": "#collapseFive",
      "aria-expanded": "false",
      "aria-controls": "collapseFive"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos del artículo")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseFive",
      "aria-labelledby": "headingFive",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingSix",
      "data-toggle": "collapse",
      "data-target": "#collapseSix",
      "aria-expanded": "false",
      "aria-controls": "collapseSix"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos de compra")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSix",
      "aria-labelledby": "headingSix",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v("Robert")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Historial Comentarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comentarios-buttom"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Escribe tu comentari"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "Nombre",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Continuar")])]), _vm._v(" "), _c('div', {
    staticClass: "text-title comments-subtitle"
  }, [_c('h1', [_vm._v("Ultimos comentarios")])]), _vm._v(" "), _c('div', {
    staticClass: "comments-block"
  }, [_c('ul', {
    staticClass: "comments-list"
  }, [_c('li', {
    staticClass: "comments-group"
  }, [_c('div', {
    staticClass: "comments-item"
  }, [_c('div', {
    staticClass: "comments-icon"
  }, [_c('i', {
    staticClass: "fas fa-comment-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "comments-message"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\r\n                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\r\n                  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\r\n                  consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\r\n                  cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\r\n                  proident, sunt in culpa qui officia deserunt mollit anim id est laborum.")]), _vm._v(" "), _c('span', {
    staticClass: "comments-message"
  }, [_vm._v("Raquel Leaño 26/2/2019 16:20")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNewTracking",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Estado de la orden")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha real de llegada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso de la orden"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Numero de la orden"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "exampleCheck1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "exampleCheck1"
    }
  }, [_vm._v("Usar el nro de tracking original: "), _c('span', [_vm._v("34TGBH56")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalTypeReplacement",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Selecciona el tipo de incidencia")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "1"
    }
  }, [_vm._v("Misma tienda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Otra tienda")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlTextarea1"
    }
  }, [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlTextarea1",
      "rows": "3"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalReplacement",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reemplazo")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Numero de orden"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Numero de tracking"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de salida aproximada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de entrada aproximada"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalRefund",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reembolso")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Monto"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de reembolso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalTest",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Evaluación de la orden de compra")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "home-tab",
      "data-toggle": "tab",
      "href": "#home",
      "role": "tab",
      "aria-controls": "home",
      "aria-selected": "true"
    }
  }, [_vm._v("Datos de Grabr")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "profile-tab",
      "data-toggle": "tab",
      "href": "#profile",
      "role": "tab",
      "aria-controls": "profile",
      "aria-selected": "false"
    }
  }, [_vm._v("Datos reales")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "home",
      "role": "tabpanel",
      "aria-labelledby": "home-tab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuestos"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "profile",
      "role": "tabpanel",
      "aria-labelledby": "profile-tab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuestos"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costos de envío"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Telefono"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalExtraInfo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de compra de adicional")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra (Final)"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Codigo de compra (Final)"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nro.de tracking"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de envío esperada (Final)"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "selectOperator"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "1"
    }
  }, [_vm._v("Jose Perez")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Luis Rodriguez")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalSuitcase",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de equipaje")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de equipaje")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Maleta")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripcion"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control null",
    attrs: {
      "rows": "3",
      "cols": "70"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Continuar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalEditUser",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de usuario")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Correo electronico"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contraseña"), _c('i', {
    staticClass: "far fa-question-circle",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Tooltip"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNewUser",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de usuario")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "form-control form-control-lg"
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v("Administrador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Operador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cliente")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Guardar")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-886eb630"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/template-view.vue
// module id = 1900
// module chunks = 1